<template>
  <div class="page">
      <h2>Presentations</h2><br>
      <presentations-list 
        :presentationsList="presentationsList"
      />
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

import PresentationsList from '../components/presentations/PresentationsList'

export default {
  name: 'Presentations',
  metaInfo() {
    return {
      title: "SAWBO RAPID Presentations",
      meta: [
        {
          name: "description",
          content: "Find recent presentations related to SAWBO RAPID."
        },
        { property: "og:title", content: "SAWBO RAPID Presentations" },
        { property: "og:image", content: "https://sawbo-animations.org/images/social_media/SAWBO_FB_Share.png" },
        { property: "og:url", content: window.location.origin + window.location.pathname },
        { property: "og:type", content: "website" }
      ],
    };
  },
  components: {
    PresentationsList
  },
  data() {
      return {
      }
  },
  computed: {
      ...mapGetters([
        'presentationsList',
      ]),
  },
  methods: {
  },
  created() {
  }
}
</script>

<style scoped>
</style>
